import React, { useState, useEffect } from 'react';
import axios from 'axios';
import URL from '../constants/ServerUrl';
import { useSearchParams, useNavigate } from 'react-router-dom';

function EditPermissions({ match }) {
  const [userdetails, setUserdetails] = useState(null);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const navigator=useNavigate();
  const token = localStorage.getItem('dairy-token');
  const username = searchParams.get('username');
  const [allowAddFarmer, setAllowAddFarmer] = useState('Not Allow')
  const [allowRateChart, setAllowRateChart] = useState('Not Allow')
  const [allowPayment, setAllowPayment] = useState('Not Allow')
  const [allowDues, setAllowDues] = useState('Not Allow')
  const [allowLedger, setAllowLedger] = useState('Not Allow')
  const [showDropDown1, setShowDropDown1] = useState(false)
  const [showDropDown2, setShowDropDown2] = useState(false)
  const [showDropDown3, setShowDropDown3] = useState(false)
  const [showDropDown4, setShowDropDown4] = useState(false)
  const [showDropDown5, setShowDropDown5] = useState(false)
 
  const permissionsOptions = [
    { value: 'Allow', label: 'Allow' },
    { value: 'Not Allow', label: 'Not Allow' },
  ]
  


  const fetchUserDetails = async () => {
    const apiUrl = `https://hamro-dairy-api.onrender.com/api/user/${username}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data; // Return the data from the API response
    } catch (err) {
      setError(err.response.data.error);
      return null; // Return null in case of an error
    }
  };

  useEffect(() => {
    // Call the fetchUserDetails function when the component mounts
    const getUserData = async () => {
      const userData = await fetchUserDetails();
      if (userData) {
        setUserdetails(userData);
        console.log(userData);
      }
    };

    getUserData();
  }, []); // Empty dependency array to run only on mount


  const fetchUserPermissions = async () => {
    try {
      if (username) {
        const res = await axios.get(`${URL}user/${username}/permissions`,{
            Authorization: `Bearer ${token}`,
        })
        setAllowAddFarmer(res.data.allowAddFarmer)
        setAllowRateChart(res.data.allowRateChart)
        setAllowPayment(res.data.allowPayment)
        setAllowDues(res.data.allowDues)
        setAllowLedger(res.data.allowLedger)
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchUserPermissions()
  }, [])

  const updateUser = async () => {
    try {
      // Fetch user information
      const userInfoResponse = await axios.get(`https://hamro-dairy-api.onrender.com/api/user/${username}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (userInfoResponse.status !== 200) {
        // Handle the case when the response status is not 200
        console.error('Error getting user info:', userInfoResponse.status, userInfoResponse.statusText);
        // You may want to throw an error or handle it differently
        return;
      }
  
      const userInfo = userInfoResponse.data;
  
      // Extract user properties from userInfo
      const userId = userInfo.userId;
      const password = userInfo.password;
      const confirmPassword = userInfo.confirmPassword;
      const mobileNo = userInfo.mobileNo;
      const contactPerson = userInfo.contactPerson;
      const address = userInfo.address;
  
      // Define the URL where you want to send the PUT request
      const updateUserURL = `${URL}user/${username}`;
  
      // Define the permissions object (make sure it's defined in your code)
      const permissions = {
        allowAddFarmer,
        allowRateChart,
        allowPayment,
        allowDues,
        allowLedger,
      };
  
      // Send the PUT request to update user information
      const updateResponse = await axios.put(`${URL}user/${username}`, {
        userId,
        username,
        password,
        confirmPassword,
        mobileNo,
        contactPerson,
        address,
        permissions,
      },{
        Authorization: `Bearer ${token}`,
      });
  
      if (updateResponse.status === 200) {
        alert('User updated successfully');
      } else {
        // Handle the case when the update request fails
        console.error('Error updating user:', updateResponse.status, updateResponse.statusText);
        // You may want to throw an error or handle it differently
      }
    } catch (err) {
      alert(err.response ? err.response.data.error : 'An error occurred while updating user');
      console.error(err);
    }
  };
  
  return (
    <div >
    <div >Select Permissions</div>

    <div>
      <select
        label={'Allow Add Farmer'}
        mode={'flat'}
        visible={showDropDown1}
        showDropDown={() => setShowDropDown1(true)}
        onDismiss={() => setShowDropDown1(false)}
        value={allowAddFarmer}
        setValue={setAllowAddFarmer}
        list={permissionsOptions}
        
        inputProps={{
        }}
      />

      <select
        label={'Allow Rate Chart'}
        mode='flat'
        visible={showDropDown2}
        showDropDown={() => setShowDropDown2(true)}
        onDismiss={() => setShowDropDown2(false)}
        value={allowRateChart}
        setValue={setAllowRateChart}
        list={permissionsOptions}
     
      />

      <select
        label={'Allow Payment'}
        mode='flat'
        visible={showDropDown3}
        showDropDown={() => setShowDropDown3(true)}
        onDismiss={() => setShowDropDown3(false)}
        value={allowPayment}
        setValue={setAllowPayment}
        list={permissionsOptions}
      />

      <select
        label={'Allow Dues'}
        mode='flat'
        visible={showDropDown4}
        showDropDown={() => setShowDropDown4(true)}
        onDismiss={() => setShowDropDown4(false)}
        value={allowDues}
        setValue={setAllowDues}
        list={permissionsOptions}
      />

      <select
        label={'Allow Ledger'}
        mode='flat'
        visible={showDropDown5}
        showDropDown={() => setShowDropDown5(true)}
        onDismiss={() => setShowDropDown5(false)}
        value={allowLedger}
        setValue={setAllowLedger}
        list={permissionsOptions}
      />
    </div>

    <div>
      <button
        mode='contained'
        onClick={() => updateUser()}
        buttonColor='#6987d0'
      >
    
      </button>
      <button
        onClick={() => {
            navigator('/users')
        }}
      >
        <div >Go Back</div>
      </button>
    </div>
  </div>
  );
}



export default EditPermissions;
